import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import Stats from '../../../pages/Stats';
import HomeStatsMobile from '../../../pages/Mobile/Stats/HomeStatsMobile';

const HomeStatsResponsive = () => {
    const { isMobile } = useResponsiveRedux(); 
    return isMobile ? <HomeStatsMobile /> : <Stats />;
};

export default HomeStatsResponsive;